import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";

@Component({
  selector: 'page-archive-std-reasons-report',
  templateUrl: 'archive-std-reasons-report.html',
})
export class ArchiveStdReasonsReportPage {

  StdResReport: any;

  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              public platform : Platform,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.loadvalues();
    });


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ArchiveStdReasonsReportPage');
  }

  loadvalues() {

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    this.StdResReport = [];

    this.service.httpcall('app_web_service/get_std_reasons_report?').subscribe(data => {

      if(data){
        this.StdResReport = data;
        console.log('MonthReport',this.StdResReport);
        loading.dismiss();
      }else{
        loading.dismiss();
      }

    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues();

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/archive-std-reasons-report/archive-std-reasons-report.ts